module.exports = __webpack_public_path__ + "static/media/99c06a75c2d10f2ad5d81a1aa870fc65.99c06a75.mp4";